import TripTravellerAllocationRecommendation from './trip-traveller-allocation-recommendation-component';
import TripTravellerAllocationFlightService from './trip-traveller-allocation-recommendation-service';

import './trip-traveller-allocation-recommendation.scss';

const MODULE_NAME = 'app.trip.traveller-allocation.recommendation';
const module = angular.module(MODULE_NAME, [])
    .directive(TripTravellerAllocationRecommendation.DIRECTIVE_NAME, TripTravellerAllocationRecommendation)
    .service('tripTravellerAllocationRecommendationService', TripTravellerAllocationFlightService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-recommendation/trip-traveller-allocation-recommendation-module.js